import PropTypes from 'prop-types';
import React, { Component } from 'react';
import isEqual from 'lodash/isEqual';
import Button from 'yoda-core-components/lib/components/Button';
import SlidePanel from 'yoda-site-components/lib/components/SlidePanel/SlidePanel';
import { AMR_CO_SHOW_ITEM_DETAILS } from 'yoda-checkout-components/lib/common/AmrConstants';
import { ITEM_DETAILS } from 'yoda-checkout-components/lib/common/LabelConstants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { ReviewShippingGroupList } from '../../LazyModules/LazyModules';

class ShowItemDetailsLink extends Component {
    static propTypes = {
        linkTitle: PropTypes.string,
        panelTitle: PropTypes.string,
    };

    static defaultProps = {
        linkTitle: 'Show Item Details',
        panelTitle: ITEM_DETAILS,
    };

    constructor() {
        super();
        this.state = { isPanelOpen: false };
        this.onClosePanel = this.onClosePanel.bind(this);
        this.onOpenPanel = this.onOpenPanel.bind(this);
        this.renderSlidePanel = this.renderSlidePanel.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !isEqual(this.props, nextProps) || this.state !== nextState;
    }

    onClosePanel() {
        /* istanbul ignore next */
        this.setState({ isPanelOpen: false });
        // Release the body scroll lock while slide panel close
        /* istanbul ignore next */
        document.body.style.position = 'inherit';
    }

    onOpenPanel(event) {
        event.preventDefault();
        this.setState({ isPanelOpen: true });
        // Lock the body scroll while slide panel open
        Object.assign(document.body.style, { top: 0, bottom: 0, left: 0, right: 0 });
    }

    renderSlidePanel() {
        const { panelTitle } = this.props;
        return (
            <SlidePanel
                panelTitle={panelTitle}
                panelTitleClass={dt(['pl-32'])}
                isOpenPanel={this.state.isPanelOpen}
                onClosePanel={this.onClosePanel}
            >
                <div>{this.state.isPanelOpen ? <ReviewShippingGroupList /> : null}</div>
            </SlidePanel>
        );
    }

    render() {
        return (
            <div id={AMR_CO_SHOW_ITEM_DETAILS} data-automation-id="at-show-items-details-wrapper">
                <Button
                    className={dt(['!font-normal', 'text-small'])}
                    buttonType="Link"
                    automationId="show-item-details-link"
                    size="Sm"
                    onClick={this.onOpenPanel}
                >
                    {this.props.linkTitle}
                </Button>
                {this.renderSlidePanel()}
            </div>
        );
    }
}

export default ShowItemDetailsLink;
